/**
 * @deprecated These values will be removed in favor of implementation of Contentful package
 */
export const CONTENTFUL_SPACE_NAME = {
  marketing: "marketing",
  product: "product",
} as const;

/**
 * @deprecated These values will be removed in favor of implementation of Contentful package
 */
export const CONTENTFUL_LOCALE = {
  cn: "zh-Hans",
  en: "en",
  es: "es-US",
  fr: "fr",
  it: "it-IT",
  nl: "nl",
  zh: "zh-Hant",
} as const;
